module.exports = __webpack_public_path__ + "static/media/Memories_2.07b3daab.jpg";